/**
 * A short "ping" for incoming customer messages, synthesized with Web Audio
 * instead of shipping an audio asset. One shared AudioContext, created lazily
 * on first use — browsers block autoplay before a user gesture, and by the
 * time a live message can arrive the agent has already interacted with the
 * page (logged in, clicked into the console), so this reliably plays.
 */

let ctx;

function getContext() {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  if (!ctx) ctx = new Ctx();
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

export function playPing() {
  try {
    const audioCtx = getContext();
    if (!audioCtx) return;

    const now = audioCtx.currentTime;
    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();

    osc.type = "sine";
    osc.frequency.setValueAtTime(880, now);
    osc.frequency.exponentialRampToValueAtTime(1320, now + 0.08);

    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(0.18, now + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.35);

    osc.connect(gain);
    gain.connect(audioCtx.destination);
    osc.start(now);
    osc.stop(now + 0.4);
  } catch {
    /* best-effort — never let a chime failure break the notification */
  }
}
